import { MetadataField } from '@/api/generatedApi';
import { DeleteMetadataFieldParameters, useDeleteMetadataField } from '@/hooks/api/metadata/useDeleteMetadataField';
import { useFetchAssetsUsingMetadataField } from '@/hooks/api/metadata/useFetchAssetsUsingMetadataField';
import { pluralize } from '@/utils/format';
import { Alert } from '@mui/material';
import { DeleteModal } from './DeleteModal';

export const DeleteMetadataFieldModal = ({
  isOpen,
  onClose,
  metadataField,
  onSuccess,
}: {
  isOpen: boolean;
  onClose: () => void;
  metadataField?: MetadataField;
  onSuccess?: (deletedField: MetadataField) => void;
}) => {
  const { total: assetCount, isLoading: isLoadingAssetCount } = useFetchAssetsUsingMetadataField(
    isOpen ? metadataField?.id : undefined
  );
  const hasAssociatedAssets = assetCount > 0;

  const mutateParameters: DeleteMetadataFieldParameters | undefined = metadataField?.id
    ? { metadataFieldId: metadataField.id, force: hasAssociatedAssets }
    : undefined;

  return (
    metadataField?.id && (
      <DeleteModal<MetadataField, DeleteMetadataFieldParameters>
        title='Delete Metadata Field'
        isOpen={isOpen}
        onClose={onClose}
        useHook={useDeleteMetadataField}
        mutateParams={mutateParameters}
        item={metadataField}
        itemName={metadataField?.name || 'this metadata field'}
        onConfirm={() => onSuccess?.(metadataField)}
        isLoading={isLoadingAssetCount}
      >
        {hasAssociatedAssets && (
          <Alert severity='warning'>
            This field has values on {pluralize(assetCount, 'asset', 'assets')}. Deleting it will remove all values from
            those assets.
          </Alert>
        )}
      </DeleteModal>
    )
  );
};
